import * as React from 'react';

function SvgShopByLake(props: React.SVGAttributes<SVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 18 22" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g stroke="currentColor" strokeWidth={1.5} fill="none" fillRule="evenodd">
        <path d="M0 13.927c2.182 0 2.182 2.368 4.38 2.368s2.198-2.368 4.396-2.368 2.198 2.368 4.396 2.368c2.197 0 2.182-2.368 4.38-2.368M0 18.616C2.182 18.616 2.182 21 4.38 21s2.198-2.384 4.396-2.384S10.974 21 13.172 21c2.197 0 2.182-2.384 4.38-2.384M13.357 4.888c0 2.538-4.643 8.481-4.643 8.481S4.071 7.426 4.071 4.888a4.643 4.643 0 019.163 0h.123z" />
      </g>
    </svg>
  );
}

export default SvgShopByLake;
